export default function IosColorFilter() {
  return (
    <div
      className="ion-icon-ios-color-filter"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M366.194,212.122c1.185-6.528,1.807-13.252,1.807-20.122c0-61.856-50.146-112-112.001-112
		c-61.857,0-112.001,50.144-112.001,112c0,6.87,0.622,13.594,1.806,20.122C98.618,225.302,64,268.606,64,320
		c0,61.855,50.144,112,112,112c31.341,0,59.67-12.879,80-33.627C276.328,419.121,304.658,432,335.999,432
		C397.854,432,448,381.855,448,320C448,268.606,413.381,225.303,366.194,212.122z M255.998,395.373
		c-0.484,0.495-0.979,0.982-1.475,1.469c-3.201-3.394-6.189-6.987-8.951-10.759c-13.561-18.525-21.574-41.366-21.574-66.083
		c0-6.869,0.622-13.594,1.807-20.121c-35.749-9.986-64.281-37.26-76.014-72.243c-1.594-4.752-2.872-9.647-3.822-14.659
		c0.942-0.29,1.882-0.589,2.835-0.854c-0.046-0.252-0.085-0.507-0.129-0.759c4.186-1.049,8.463-1.867,12.82-2.43
		C166.243,208.319,171.084,208,176,208c31.341,0,59.67,12.878,80,33.626C276.328,220.878,304.658,208,335.999,208
		c4.916,0,9.757,0.319,14.506,0.934c4.355,0.563,8.633,1.38,12.816,2.429c-0.043,0.253-0.082,0.507-0.129,0.76
		c0.955,0.267,1.895,0.564,2.838,0.855c-0.949,5.012-2.229,9.907-3.822,14.658c-11.732,34.983-40.266,62.257-76.013,72.242
		c1.185,6.528,1.807,13.253,1.807,20.122c0,24.717-8.014,47.558-21.574,66.083c-2.762,3.772-5.752,7.367-8.953,10.76
		C256.979,396.356,256.484,395.869,255.998,395.373z"/>
	<path d="M270.506,303.067c-4.749,0.614-9.59,0.934-14.506,0.934s-9.758-0.319-14.506-0.934c-0.982,5.498-1.496,11.156-1.496,16.933
		c0,19.58,5.898,37.806,16.002,53.005c10.104-15.199,16.002-33.425,16.002-53.005C272.002,314.224,271.488,308.565,270.506,303.067z
		"/>
	<path d="M346.313,224.555c-3.39-0.364-6.83-0.556-10.314-0.556c-27.354,0-52.069,11.5-69.571,29.917
		c6.725,9.188,12.088,19.434,15.781,30.448C311.964,275.909,335.874,253.428,346.313,224.555z"/>
	<path d="M266.314,287.445c-2.625-7.262-6.105-14.119-10.314-20.451c-4.209,6.332-7.689,13.189-10.314,20.451
		c3.389,0.364,6.83,0.556,10.314,0.556S262.925,287.81,266.314,287.445z"/>
	<path d="M176,223.999c-3.484,0-6.925,0.191-10.314,0.556c10.439,28.873,34.349,51.354,64.106,59.81
		c3.693-11.015,9.055-21.261,15.781-30.448C228.07,235.499,203.353,223.999,176,223.999z"/>
</g>
</svg>
`,
      }}
    />
  )
}
